import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector: 'service-provider-modal-component',
    templateUrl: './service-provider-modal.component.html',
    styleUrls: ['./service-provider-modal.component.scss'],
})
export class ServiceProviderModalComponent implements OnChanges {
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() form: FormGroup;
    @Input() formSubmitted: boolean;
    @Input() itemLanguage: string;
    @Input() authService: AuthService;
    @Input() helpRawData = '';
    @Input() languages: Object[];
    @Input() categories: Object[];
    @Input() subcategories: Object[];
    @Input() companies: Object[];
    @Input() diagnoses: Object[];
    @Input() ageGroups: Object[];
    @Input() serviceProviderLanguage: Object[];
    @Input() countries: Object[];
    @Input() insurances: Object[];
    @Input() logos: Object[];
    @Input() logoPath = '';

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    @ViewChild('formDirective') private formDirective: NgForm;

    subcategoryList = [];
    contraindicationDiagnoses = [];

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['params'] && this.formDirective) {
            this.formDirective.resetForm();
        }

        if (this.form) {
            this.updateSubCategory(this.form.controls['category_id'].value);
        }

        if (changes['diagnoses']) {
            this.contraindicationDiagnoses = _.cloneDeep(this.diagnoses);
        }
    }

    removeDiagnosis(diagnosis){
        const data = this.form.controls['diagnosis_ids'].value;
        _.remove(data, function(item){
            return item == diagnosis['id'];
        });
        return this.form.controls['diagnosis_ids'].setValue(data);
    }

    removeContraindication(diagnosis){
        const data = this.form.controls['contraindications_ids'].value;
        _.remove(data, function(item){
            return item == diagnosis['id'];
        });
        return this.form.controls['contraindications_ids'].setValue(data);
    }

    updateSubCategory(value) {
        if (!value) {
            this.subcategoryList = this.subcategories;
            return;
        }
        this.subcategoryList = this.subcategories.filter(item => item['category_id'] === value );
    }

    updateLogo(value) {
        let logo = this.logos.find(item => item['id'] === value );
        let logoUrl = logo ? this.logoPath + logo['logo'] : null;
        this.form.controls['logo_url'].setValue(logoUrl);
    }
}
